export default {
  NONE: 'none', // not supported or should not be used
  COMBINED: 'combined', // files and directories can be selected simultaneously with one control
  SEPARATED: 'separated', // separate controls for files and directories selection
};
